<template>
  <main>
    <ec-page-heading
      :sub-title="subTitle"
      :title="pageTitle"
      class="intro-text wrapper pt-5 pb-5"
    />
    <section
      id="webshop"
      class="wrapper pt-5 pb-5"
    >
      <div class="container">
        <div id="enjoj-webshop" :webshop-id="webshopId" :header-height="headerHeight" theme-color="#"></div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ecPageHeading from '@/components/General/PageHeading'
import Location from '@/mixins/Location'
import buildWebshop from 'ec-webshop-pwa'

export default {
  name: 'ec-webshop-store',
  components: {
    ecPageHeading
  },
  mixins: [Location],
  data () {
    return {
      isLoaded: false,
      webshopId: -1
    }
  },
  computed: {
    ...mapState('webshop', {
      headerHeight: state => state.headerHeight,
    }),
    pageTitle () {
      return 'Webshop'
    },
    subTitle () {
      return 'Koop veilig en snel online'
    }
  },
  beforeRouteEnter (to, from, next) {
    let splitted = to.params.slug.split('-')
    let webshopId = Number(splitted[splitted.length - 1])

    // remove id from slug
    splitted.splice(-1, 1)

    // set slug without id
    if (isNaN(webshopId) || webshopId === 0) {
      next({ name: 'notfound' })
      return
    }

    next(vm => {
      if (from.name === null) {
        vm.getSiteData(to.params.city)
      }

      vm.isLoaded = true
    })
  },
  methods: {
    ...mapMutations('webshop', [
      'setHeaderHeight'
    ]),
    setWebshopId () {
      const splitted = this.$route.params.slug.split('-')
      this.webshopId = Number(splitted[splitted.length -1])
    }
  },
  created () {
    this.setHeaderHeight({
      desktop: 0,
      mobile: 0
    })
    this.setWebshopId()
  },
  mounted() {
    buildWebshop()
  }
}
</script>
